var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.59 19.05a4.05 4.05 0 1 1-5.73 5.72 4.05 4.05 0 0 1 5.73-5.72m-13.19-7.23a6.23 6.23 0 1 1-8.8 8.82 6.23 6.23 0 0 1 8.8-8.82m-16.26 7.23a4.05 4.05 0 1 1-5.72 5.72 4.05 4.05 0 0 1 5.72-5.72m33.86 18.95v-2.2a5 5 0 0 0-5-5h-1.6m-37.4 7.2v-2.2a5 5 0 0 1 5-5h1.6m26.08 7.2v-3.2a7 7 0 0 0-7-7h-7.36a7 7 0 0 0-7 7v3.2",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.ddcb6356c782a5ccb3363539c680d86d.svg";
export { ForwardRef as ReactComponent };